import { Button, FormControl, InputLabel, MenuItem, Paper, Select, TextField, Typography } from '@mui/material';
import axios from '../util/Axios';
import { useEffect, useState } from 'react';
// import { VALID_HOSPITALS } from '../util/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { EDIT_PROFILE } from '../store/actions/GlobalActions';
import { useTranslation } from 'react-i18next';
import { validPassword, notEmpty } from '../util/Validation';

export default function Profile() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state.GlobalReducer.loggedUser);
  const [hospital, setHospital] = useState(loggedUser?.hospital || '');
  const [phone, setPhone] = useState(loggedUser?.phone || '');
  const [name, setName] = useState(loggedUser?.name || '');

  const [password, setPassword] = useState('');
  const [repeatedPassword, setRepeadetPassword] = useState('');

  const [hospitals, setHospitals] = useState([]);

  useEffect(() => {
    axios.get('/hospitals')
      .then(response => {
        setHospitals(response.data);
      });
  }, []);

  useEffect(() => {
    setHospital(loggedUser?.hospital || '');
    setPhone(loggedUser?.phone || '');
    setName(loggedUser?.name || '');
  }, [loggedUser?.hospital, loggedUser?.phone, loggedUser?.name]);

  const editProfile = () => {
    axios('/users/doctors/edit', {
      method: 'PUT',
      data: {
        name: name,
        phone: phone,
        hospital: hospital,
      },
    }).then((data) => {
      dispatch({ type: EDIT_PROFILE, payload: data.data });
    });
  };

  const passwordDoNotMatch = () => {
    if (repeatedPassword === '') {
      return false;
    }
    return password !== repeatedPassword;
  };

  const handleChangePassword = () => {
    axios('/users/admin/changepass', {
      method: 'POST',
      data: {
        newPassword: repeatedPassword,
        email: loggedUser.email
      }
    }).then(() => {
      setPassword('');
      setRepeadetPassword('');
    });
  };

  const formElementStyles = {
    width: '90%',
    margin: 'auto',
    marginBottom: '16px',
  };

  const renderPage = () => {
    return (
      <>
        <Paper
          sx={{
            padding: '16px',
            minWidth: '550px',
            width: '60%',
            marginTop: '64px',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            component="h3"
            sx={{
              fontSize: '1.5em',
              textAlign: 'center',
              marginBottom: '8px',
            }}
          >
            Edit Profile
          </Typography>
          <TextField
            sx={formElementStyles}
            variant="standard"
            label="Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
          <TextField
            sx={formElementStyles}
            variant="standard"
            label="Phone"
            value={phone}
            onChange={(event) => setPhone(event.target.value)}
          />
          <TextField
            sx={formElementStyles}
            variant="standard"
            label="Hospital"
            disabled
            value={hospital}
          />
          <FormControl
            sx={formElementStyles}
            variant="standard"
          >
            <InputLabel>Change Hospital To</InputLabel>
            <Select value={hospital} onChange={(event) => setHospital(event.target.value)}>
              {hospitals.map((h) => (
                <MenuItem key={h.id} value={h.name}>
                  {h.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            sx={formElementStyles}
            variant="contained"
            onClick={() => editProfile()}
          >
            Save Changes
          </Button>

          <Typography
            component="h4"
            sx={{
              fontSize: '1.2em',
              textAlign: 'center',
              marginBottom: '8px',
              marginTop: '16px'
            }}
          >
            Change password
          </Typography>
          <TextField
            sx={formElementStyles}
            required
            type="password"
            helperText={t('password_help')}
            error={!validPassword(password)}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            label={t('enter_password')}
          ></TextField>
          <TextField
            sx={formElementStyles}
            required
            type="password"
            error={passwordDoNotMatch()}
            helperText={passwordDoNotMatch() ? t('password_mismatch') : ''}
            value={repeatedPassword}
            onChange={(event) => setRepeadetPassword(event.target.value)}
            label={t('repeat_password')}
          ></TextField>
          <Button
            sx={formElementStyles}
            disabled={!notEmpty(password, validPassword) || password !== repeatedPassword}
            variant="contained"
            color="primary"
            onClick={handleChangePassword}
          >
            Save
          </Button>
        </Paper>
      </>
    );
  };

  return loggedUser ? renderPage() : <></>;
}
